import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AnonUserService } from '@api';
import { of } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { QueryParameterService } from '@app/core/services/query-parameter.service';

@Component({
  selector: 'app-verify-email-container',
  template: `
    <p role="article">
      @if (status$ | async; as status) {
        @if (status === 'verified') {
          Your email has been verified. You may now close this tab.
        } @else if (status === 'error') {
          There was a problem verifying your email address.
        }
      } @else {
        Verifying...
      }
    </p>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class VerifyEmailContainer {
  private userService = inject(AnonUserService);
  private queryParameterService = inject(QueryParameterService);

  status$ = this.queryParameterService.getQueryParameter('nonce').pipe(
    switchMap((nonce) =>
      this.userService.anonUserVerifyEmailCreate({
        verifyRequest: {
          nonce: nonce ?? '',
        },
      })
    ),
    map(() => 'verified'),
    catchError(() => {
      return of('error');
    })
  );
}
